import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
    boxShadow: "10px 10px 40px rgba(0, 0, 0, 0.25)",
    borderRadius: "20px",
  },
  form: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  fileInput: {
    width: "97%",
    margin: "10px 0",
  },
  buttonSubmit: {
    marginBottom: 15,
    background: "linear-gradient(45deg, #343D48 30%, #366994 90%)",
    border: 0,
    borderRadius: 3,
    boxShadow: "5px 10px 10px rgba(0, 0, 0, 0.25)",
    color: "white",
    height: 48,
    padding: "0 30px",
  },
  buttonClear: {
    background: "linear-gradient(45deg, #E44545 30%, #E26E6E 90%)",
    border: 0,
    borderRadius: 3,
    boxShadow: "5px 10px 10px rgba(0, 0, 0, 0.25)",
    color: "white",
    height: 48,
    padding: "0 30px",
    marginBottom: 15,
  },
}));
